export enum DismissibleInfoBoxKey {
  ReferralPatientLetterInfo = 'referral-patient-letter-info',
}
